import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { ArticleSpeechInlineWidgetProps } from "~/components/article/article-speech/article-speech-inline-widget";
import { ArticleSpeechInlineWidget } from "~/components/article/article-speech/article-speech-inline-widget";
import { HeaderArticleSpeech } from "~/components/header/header-article-speech";
import { useCurrentArticleIds } from "~/lib/current-item";
import type { articleSpeechPlayerPortalArticle$key } from "~/queries/__generated__/articleSpeechPlayerPortalArticle.graphql";

type Props = {
  reference: articleSpeechPlayerPortalArticle$key;
  withCurrentArticle?: boolean;
} & Omit<ArticleSpeechInlineWidgetProps, "reference">;

export const ArticleSpeechPlayerPortal: FunctionComponent<Props> = ({
  reference,
  withCurrentArticle = true,
  ...props
}) => {
  const article = useFragment(
    graphql`
      fragment articleSpeechPlayerPortalArticle on Article {
        entityId
        ...articleSpeechInlineWidgetArticle
      }
    `,
    reference,
  );

  const { currentArticleId } = useCurrentArticleIds();
  if (withCurrentArticle && article.entityId !== currentArticleId) return null;

  return (
    <HeaderArticleSpeech>
      <ArticleSpeechInlineWidget {...props} reference={article} />
    </HeaderArticleSpeech>
  );
};
ArticleSpeechPlayerPortal.displayName = "ArticleSpeechPlayerPortal";
